// extracted by mini-css-extract-plugin
export var active = "_jy-2";
export var recordingDot = "_jy-1";
export var recordingIndicator = "_jy-0";